export const UserIsInOryResetPasswordResponseStatus = 409;
export const OryApiRequestCancelTokenId = 'ory-request-cancelled';
export const MaxWrongCurrentPasswordAttemptsDuringChangePassword = 3;
export const OryPasswordMaxLength = 72;
export const LoginMFAAssuranceLevel = 'aal2';
